import { render, staticRenderFns } from "./ConfirmBulkActionModal.vue?vue&type=template&id=2f5707fe"
import script from "./ConfirmBulkActionModal.vue?vue&type=script&lang=js"
export * from "./ConfirmBulkActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports